module.exports = __webpack_public_path__ + "assets/icons/edit-calendar-663f.svg";